import TelemedicineFinishedContainer from './TelemedicineFinishedContainer';

export default TelemedicineFinishedContainer;
